/**
 * Route for `affiliate-referral-builder`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AffiliateReferralBuilderPage } from "../features/affiliate-referral-builder/AffiliateReferralBuilderPage";

export const affiliateReferralBuilderRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliate-referral-builder",
	component: AffiliateReferralBuilderPage,
});

export default affiliateReferralBuilderRoute;
